export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20')
];

export const server_loads = [];

export const dictionary = {
		"/": [6],
		"/storeroom": [9,[4]],
		"/storeroom/companies": [10,[4]],
		"/storeroom/companies/create": [12,[4]],
		"/storeroom/companies/[id=integer]": [11,[4]],
		"/storeroom/employees": [13,[4]],
		"/storeroom/qrs": [14,[4]],
		"/storeroom/qrs/create": [16,[4]],
		"/storeroom/qrs/[id=integer]": [15,[4]],
		"/storeroom/tips": [17,[4,5]],
		"/storeroom/users": [18,[4]],
		"/storeroom/users/create": [20,[4]],
		"/storeroom/users/[id=integer]": [19,[4]],
		"/[lang=lang]": [7,[2]],
		"/[lang=lang]/[qr]": [8,[2,3]]
	};

export const hooks = {
	handleError: (({ error }) => { console.error(error) }),

	reroute: (() => {})
};

export { default as root } from '../root.svelte';